"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 *
 * Does form state management and validation.
 * NOTE: in handleChange method provide a deep copy of initial object
 *
 * @param initialValues       : the initial state of the form
 * @param validationSchema    : A yup schema only
 * @param onSubmit            : function to be triggered when all data is correct
 *
 * @returns                   : object {
 *                                        names,
 *                                        errors
 *                                        initialValues,
 *                                        values,
 *                                        touched,
 *                                        handleSubmit
 *                                        handleChange
 *                                        handleBlur
 *                                        resetForm
 *                                        resetValues
 *                                        isValid
 *                                      }
 *
 */
var useValidation = function useValidation(_ref) {
  var initialValues = _ref.initialValues,
      validationSchema = _ref.validationSchema,
      onSubmit = _ref.onSubmit;

  var _useState = (0, _react.useState)(initialValues),
      _useState2 = _slicedToArray(_useState, 2),
      initialValuesObject = _useState2[0],
      setInitialValuesObject = _useState2[1];

  var _useState3 = (0, _react.useState)(getAllnames(initialValues)),
      _useState4 = _slicedToArray(_useState3, 2),
      names = _useState4[0],
      setNames = _useState4[1];

  var _useState5 = (0, _react.useState)(nullAll(initialValues)),
      _useState6 = _slicedToArray(_useState5, 2),
      errors = _useState6[0],
      setErrors = _useState6[1];

  var _useState7 = (0, _react.useState)(nullAll(initialValues)),
      _useState8 = _slicedToArray(_useState7, 2),
      touched = _useState8[0],
      setTouched = _useState8[1];

  var _useState9 = (0, _react.useState)(_objectSpread({}, initialValues)),
      _useState10 = _slicedToArray(_useState9, 2),
      values = _useState10[0],
      setValues = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = _slicedToArray(_useState11, 2),
      context = _useState12[0],
      setContext = _useState12[1];

  var _useState13 = (0, _react.useState)(validationSchema),
      _useState14 = _slicedToArray(_useState13, 2),
      schema = _useState14[0],
      setSchema = _useState14[1];

  var addDynamicFields = function addDynamicFields(dynamicValidationSchema, dynamicInitialValues) {
    setSchema(schema.concat(dynamicValidationSchema));
    var collectAllNewKeys = {};
    var collectAllValueKeys = {};
    var collectAllNames = {};

    for (var key in dynamicInitialValues) {
      if (!values[key]) {
        collectAllValueKeys[key] = dynamicInitialValues[key];
        collectAllNewKeys[key] = null;
        collectAllNames[key] = key;
      }
    }

    setErrors(function () {
      return _objectSpread(_objectSpread({}, errors), collectAllNewKeys);
    });
    setTouched(function () {
      return _objectSpread(_objectSpread({}, touched), collectAllNewKeys);
    });
    setValues(function () {
      return _objectSpread(_objectSpread({}, values), collectAllValueKeys);
    });
    setNames(function () {
      return _objectSpread(_objectSpread({}, names), collectAllNames);
    });
    setInitialValuesObject(function () {
      return _objectSpread(_objectSpread({}, values), collectAllValueKeys);
    });
  };

  var deleteDynamicFields = function deleteDynamicFields(dynamicFieldsKeys) {
    setSchema(validationSchema);
    var originalValues = values;
    var originalErrors = errors;
    var originalTouched = touched;
    var originalNames = names;

    for (var keys in dynamicFieldsKeys) {
      delete originalValues[keys];
      delete originalErrors[keys];
      delete originalTouched[keys];
      delete originalNames[keys];
    }

    setErrors(function () {
      return originalErrors;
    });
    setTouched(function () {
      return originalTouched;
    });
    setValues(function () {
      return originalValues;
    });
    setNames(function () {
      return originalNames;
    });
  };

  (0, _react.useEffect)(function () {
    // context value makes async validation run only on 
    // a certain field if it's handleBlur is called
    schema.validate(values, {
      abortEarly: false,
      context: context
    }).then(function () {
      setErrors(function () {
        return nullAll(initialValues);
      });
      setContext('');
    }).catch(function (err) {
      var _err$inner;

      var errorsAtSubmit = nullAll(initialValues);
      err === null || err === void 0 ? void 0 : (_err$inner = err.inner) === null || _err$inner === void 0 ? void 0 : _err$inner.forEach(function (e) {
        errorsAtSubmit[e.path] = e.message;
      });
      setErrors(function () {
        return errorsAtSubmit;
      });
    });
  }, [values]);
  (0, _react.useEffect)(function () {
    if (allTouched(touched)) {
      //NOTE: Should not get called in case of handleSubmit when all fields are touched
      validate();
    }
  }, [values, touched]);
  (0, _react.useEffect)(function () {
    if (context) {
      schema.validate(values, {
        abortEarly: false,
        context: context
      }).then(function () {
        setErrors(function () {
          return nullAll(initialValues);
        });
        setContext('');
      }).catch(function (err) {
        var _err$inner2;

        var errorsAtSubmit = nullAll(initialValues);
        err === null || err === void 0 ? void 0 : (_err$inner2 = err.inner) === null || _err$inner2 === void 0 ? void 0 : _err$inner2.forEach(function (e) {
          errorsAtSubmit[e.path] = e.message;
        });
        setErrors(function () {
          return errorsAtSubmit;
        });
        setContext('');
      });
    }
  }, [context]);

  var validate = function validate() {
    schema.validate(values, {
      abortEarly: false
    }).then(function () {
      setErrors(function () {
        return nullAll(initialValues);
      });
    }).catch(function (err) {
      var _err$inner3;

      var errorsAtSubmit = nullAll(initialValues);
      err === null || err === void 0 ? void 0 : (_err$inner3 = err.inner) === null || _err$inner3 === void 0 ? void 0 : _err$inner3.forEach(function (e) {
        errorsAtSubmit[e.path] = e.message;
      });
      setErrors(function () {
        return errorsAtSubmit;
      });
    });
  };

  var handleChange = function handleChange(label, value) {
    setContext('');
    setValues(function (values) {
      return _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, label, value));
    });
  };

  var handleBlur = function handleBlur(label) {
    setTouched(function (touched) {
      return _objectSpread(_objectSpread({}, touched), {}, _defineProperty({}, label, true));
    });
    setContext(label);
  };

  var handleSubmit = function handleSubmit() {
    setTouched(touchAll(values));
    schema.validate(values, {
      abortEarly: false,
      context: 'all'
    }).then(function () {
      setErrors(function () {
        return nullAll(values);
      });
      onSubmit(values);
    }).catch(function (err) {
      var _err$inner4;

      var errorsAtSubmit = nullAll(values);
      err === null || err === void 0 ? void 0 : (_err$inner4 = err.inner) === null || _err$inner4 === void 0 ? void 0 : _err$inner4.forEach(function (e) {
        // NOTE: This is required to Indicate to developer,
        // the errors which are not related to validation
        console.log(e.message);
        errorsAtSubmit[e.path] = e.message;
      });
      setErrors(function () {
        return errorsAtSubmit;
      });
    });
  };

  var resetForm = function resetForm() {
    setTouched(function () {
      return nullAll(initialValuesObject);
    });
    setErrors(function () {
      return nullAll(initialValuesObject);
    });
    setValues(function () {
      return _objectSpread({}, initialValuesObject);
    });
  };

  var resetValues = function resetValues(obj) {
    setValues(function () {
      return _objectSpread({}, obj);
    });
  };

  var isValid = function isValid() {
    var valid = true;

    for (var key in errors) {
      if (errors[key]) {
        valid = false;
        break;
      }
    }

    return valid;
  };

  return {
    names: names,
    errors: errors,
    initialValues: initialValues,
    values: values,
    touched: touched,
    handleSubmit: handleSubmit,
    handleChange: handleChange,
    handleBlur: handleBlur,
    resetForm: resetForm,
    resetValues: resetValues,
    isValid: isValid,
    addDynamicFields: addDynamicFields,
    deleteDynamicFields: deleteDynamicFields
  };
};

var nullAll = function nullAll(values) {
  var obj = {};

  for (var property in values) {
    obj = _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, property, null));
  }

  return obj;
};

var touchAll = function touchAll(values) {
  var obj = {};

  for (var property in values) {
    obj = _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, property, true));
  }

  return obj;
};

var getAllnames = function getAllnames(values) {
  var obj = {};

  for (var property in values) {
    obj = _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, property, property));
  }

  return obj;
};

var allTouched = function allTouched(touched) {
  for (var keys in touched) {
    if (!touched[keys]) {
      return false;
    }
  }

  return true;
};

var _default = useValidation;
exports.default = _default;